import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";

const LOGO_2025 = "https://customer-assets.emergentagent.com/job_real-estate-hub-147/artifacts/fbq2gvll_LOGO_2025.png";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#333333] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 lg:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-10 items-start">
          {/* Brand */}
          <div className="lg:col-span-1 flex flex-col items-center lg:items-start">
            <img
              src={LOGO_2025}
              alt="Vingt-Neuf Immobilier"
              className="h-36 object-contain mb-5"
            />
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-[11px] uppercase tracking-[0.2em] font-medium text-white/40 mb-6">
              Navigation
            </h4>
            <div className="space-y-3">
              {[
                { to: "/", label: "Accueil" },
                { to: "/biens", label: "Nos biens" },
                { to: "/a-propos", label: "L'agence" },
                { to: "/actualites", label: "Actualités" },
                { to: "/contact", label: "Contact" },
              ].map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="block text-sm text-white/60 hover:text-[#699ab6] transition-colors duration-300"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-[11px] uppercase tracking-[0.2em] font-medium text-white/40 mb-6">
              Services
            </h4>
            <div className="space-y-3">
              {["Vente immobilière", "Programmes neufs", "Conseil juridique", "Estimation gratuite"].map(
                (service) => (
                  <p key={service} className="text-sm text-white/60">
                    {service}
                  </p>
                )
              )}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-[11px] uppercase tracking-[0.2em] font-medium text-white/40 mb-6">
              Contact
            </h4>
            <div className="space-y-4">
              <a
                href="tel:+41223000262"
                className="flex items-center gap-3 text-sm text-white/60 hover:text-[#699ab6] transition-colors"
              >
                <Phone className="w-4 h-4 flex-shrink-0" />
                +41 22 300 02 62
              </a>
              <a
                href="mailto:info@vingt-neuf.ch"
                className="flex items-center gap-3 text-sm text-white/60 hover:text-[#699ab6] transition-colors"
              >
                <Mail className="w-4 h-4 flex-shrink-0" />
                info@vingt-neuf.ch
              </a>
              <div className="flex items-start gap-3 text-sm text-white/60">
                <MapPin className="w-4 h-4 flex-shrink-0 mt-0.5" />
                <a
                  href="https://www.google.com/maps/place/VINGT-NEUF+Immobilier+S%C3%A0rl./@46.1804324,6.1379392,800m/data=!3m2!1e3!4b1!4m6!3m5!1s0x478c7bce8e61b54b:0x9e532f788d786bc6!8m2!3d46.1804287!4d6.1405141!16s%2Fg%2F11h4w9f590?entry=ttu&g_ep=EgoyMDI2MDIyNS4wIKXMDSoASAFQAw%3D%3D"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[#699ab6] transition-colors"
                >
                  Rue Ancienne 55<br />1227 Carouge, Genève
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-white/30 font-light">
            &copy; {new Date().getFullYear()} Vingt-Neuf Immobilier. Tous droits réservés.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-white/30 hover:text-white/60 transition-colors">
              Mentions légales
            </a>
            <a href="#" className="text-xs text-white/30 hover:text-white/60 transition-colors">
              Confidentialité
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
